module.exports = __webpack_public_path__ + "img/paper_download.3e3d13db.svg";